/**
 * package: com.inq.events
 * class: Event
 * root Object
 * @constructor
 * @param {string} type
 * @param {Event} originalEvent
 */
com.inq.events.Event = function(type, originalEvent) {
	this.type = type;
	this.originalEvent = originalEvent;
};
$hxClasses['com.inq.events.Event'] = com.inq.events.Event;
/** @private @type {Array} */
com.inq.events.Event.__name__ = ["com","inq","events","Event"];
/** @type {string} */
com.inq.events.Event.ID3 = null;
/** @type {string} */
com.inq.events.Event.ADDED_TO_STAGE = null;
/** @type {string} */
com.inq.events.Event.REMOVED_FROM_STAGE = null;
/** @type {string} */
com.inq.events.Event.prototype.type = null;
/** @type {null} */
com.inq.events.Event.prototype.target = null;
/** @type {number} */
com.inq.events.Event.prototype.eventPhase = null;
/** @type {null} */
com.inq.events.Event.prototype.currentTarget = null;
/** @type {boolean} */
com.inq.events.Event.prototype.cancelable = null;
/** @type {boolean} */
com.inq.events.Event.prototype.bubbles = null;
/** @type {com.inq.events.Event} */
com.inq.events.Event.prototype.__class__ = com.inq.events.Event;
/** @type {string} */
com.inq.events.Event.ACTIVATE = "activate";

/** @type {string} */
com.inq.events.Event.ADDED = "added";

/** @type {string} */
com.inq.events.Event.CANCEL = "cancel";

/** @type {string} */
com.inq.events.Event.CHANGE = "change";

/** @type {string} */
com.inq.events.Event.CLOSE = "close";

/** @type {string} */
com.inq.events.Event.COMPLETE = "complete";

/** @type {string} */
com.inq.events.Event.CONNECT = "connect";

/** @type {string} */
com.inq.events.Event.DEACTIVATE = "deactivate";

/** @type {string} */
com.inq.events.Event.ENTER_FRAME = "enterFrame";

/** @type {string} */
com.inq.events.Event.INIT = "init";

/** @type {string} */
com.inq.events.Event.MOUSE_LEAVE = "mouseLeave";

/** @type {string} */
com.inq.events.Event.OPEN = "open";

/** @type {string} */
com.inq.events.Event.REMOVED = "removed";

/** @type {string} */
com.inq.events.Event.RENDER = "render";

/** @type {string} */
com.inq.events.Event.RESIZE = "resize";

/** @type {string} */
com.inq.events.Event.SCROLL = "scroll";

/** @type {string} */
com.inq.events.Event.SELECT = "select";

/** @type {string} */
com.inq.events.Event.SOUND_COMPLETE = "soundComplete";

/** @type {string} */
com.inq.events.Event.TAB_CHILDREN_CHANGE = "tabChildrenChange";

/** @type {string} */
com.inq.events.Event.TAB_ENABLED_CHANGE = "tabEnabledChange";

/** @type {string} */
com.inq.events.Event.TAB_INDEX_CHANGE = "tabIndexChange";

/** @type {string} */
com.inq.events.Event.UNLOAD = "unload";

/** @type {string} */
com.inq.events.Event.UNAUTHORIZED = "unauthorized";

/** @type {string} */
com.inq.events.Event.BAD_GATEAWAY = "badGateway";

/** @type {string} */
com.inq.events.Event.SERVICE_UNAVAILABLE = "serviceUnavailable";

/** @type {string} */
com.inq.events.Event.NETWORK_ERROR = "networkError";

/** @type {string} */
com.inq.events.Event.BAD_REQUEST = "badRequest";